module.exports = __webpack_public_path__ + "img/face-sleeping.25f040f6.svg";